















import Vue from 'vue';
import { mapGetters } from 'vuex';

import BoxWrapper from '../../components/box-wrapper.vue';
import RegisterProgress from '../../components/register-progress.vue';
import { makeMetaInfo } from '../../router/utils/meta';
import CvForm from './form.vue';
import * as RegistrationStore from '../../store/modules/register';
import * as ErrorStore from '../../store/modules/error';
import * as UiStore from '../../store/modules/ui';

export default Vue.extend({
  metaInfo: makeMetaInfo({
    title: '新規登録',
    description: 'プロフの登録はこちらから。',
  }),
  components: {
    BoxWrapper,
    CvForm,
    RegisterProgress,
  },
  computed: {
    ...mapGetters(RegistrationStore.namespace, ['profileInfo']),
    ...mapGetters(ErrorStore.namespace, ['errors']),
    ...mapGetters(UiStore.namespace, ['isLoading']),
  },
  methods: {
    async onSubmit({
      full_name,
      birthday,
      sex,
      email,
      phone_number,
      location,
      headline,
      website_url,
      profile_image,
    }: RegistrationStore.ProfileInfo) {
      await this.$store.dispatch(
        RegistrationStore.UpdateProfileInfo.namespaced({
          full_name,
          birthday,
          sex,
          email,
          phone_number,
          location,
          headline,
          website_url,
          profile_image,
        })
      );
      this.$router.push({ name: 'photo_path' });
    },
  },
});
